// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea95469c","453":"c4619f11","732":"1839eb36","977":"11d53d67"}[chunkId] + ".chunk.js";
};